module.exports = __webpack_public_path__ + "img/Bear Trap.76a26758.png";